<template>
  <div>
    <v-row class="pt-2">
      <h3>{{ title }}</h3>
    </v-row>

    <v-row>
      <v-col cols="12" class="countrySelectCol pa-0">
        <v-autocomplete
          v-model="s"
          label="Subsections"
          :items="itemList"
          multiple
          chips
          small-chips
          deletable-chips
          clearable
          single-line
          dense
          @change="handleSelect"
        >
          <template v-slot:prepend-item>
            <v-list-item
              ripple
              @mousedown.prevent
              @click="selectAllSubsections"
            >
              <v-list-item-action>
                <v-icon :color="s.length > 0 ? 'primary' : ''">
                  {{ subsectionAllIcon }}
                </v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>
                  Select All
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-divider class="mt-2"></v-divider>
          </template>
        </v-autocomplete>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  name: "SelectAllDropdownSelector",
  props: {
    selection: {
      type: Array,
      require: true,
    },
    itemList: {
      type: Array,
      require: true,
    },
    title: {
      type: String,
      require: true,
    },
  },
  computed: {
    subsectionsSelectedAll() {
      return this.s.length === this.itemList.length;
    },
    subsectionsSelectedSome() {
      return this.s.length > 0 && !this.subsectionsSelectedAll;
    },
    subsectionAllIcon() {
      if (this.subsectionsSelectedAll) {
        return "mdi-close-box";
      }
      if (this.subsectionsSelectedSome) {
        return "mdi-minus-box";
      }
      return "mdi-checkbox-blank-outline";
    },
  },
  data() {
    return {
      s: this.selection,
    };
  },
  methods: {
    handleSelect(input) {
      this.$emit("select", input);
    },
    selectAllSubsections() {
      this.$nextTick(() => {
        if (this.s.length === this.itemList.length) {
          this.s = [];
        } else {
          this.s = this.itemList.slice();
        }
      });
    },
  },
  model: {
    prop: "selection",
    event: "select",
  },
  watch: {},
};
</script>

<style scoped></style>
